//@ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InputLabel } from '@material-ui/core';
import helpers from '../utils/fieldsHelper';
var useStyles = makeStyles({
  root: {
    '& span': {
      '& p': {
        marginTop: 0,
        marginBottom: 0
      }
    }
  }
}, {
  name: 'ECFormFieldLabel'
});
/**
 *
 * @param {import('../components/types').FormFieldLabelProps} params
 */

var FormFieldLabel = function FormFieldLabel(_ref) {
  var caption = _ref.caption;
  var classes = useStyles({});
  var content = helpers.getHtmlMarkup(caption);
  return React.createElement("div", null, React.createElement(InputLabel, {
    classes: classes,
    shrink: false,
    className: "form-label"
  }, React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  })));
};

export default React.memo(FormFieldLabel);